import { render, staticRenderFns } from "./ClientsEditItem.vue?vue&type=template&id=12f77bfd&"
import script from "./ClientsEditItem.vue?vue&type=script&lang=js&"
export * from "./ClientsEditItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientsEditItem.vue?vue&type=style&index=0&id=12f77bfd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports